import React from "react";

const ServicePromo = () => {
  return (
    <section className="services-icon ptb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="section-heading text-center">
              <h2>Services We Provide</h2>
              <p>
                Discover the range of services we offer to help your
                business grow, innovate, and succeed through technology.
              </p>
            </div>
            ,
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center mt-3 border-bottom border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/coding.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="service-info-wrap">
                <h3 className="h5">Web Development</h3>
                <p>
                  We build fast, responsive, and user-friendly
                  websites that help your business stand out online.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center mt-3 border-bottom border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/app-development.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="service-info-wrap">
                <h3 className="h5">App Development</h3>
                <p>
                  Powerful, intuitive mobile and web applications
                  designed to bring your ideas to life and engage users everywhere.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center mt-3 border-bottom">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/shield.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="service-info-wrap">
                <h3 className="h5">Data Sceurity</h3>
                <p>
                  Protecting your valuable data with robust security
                  measures to ensure privacy, integrity, and peace of mind.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/curve.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="feature-info-wrap">
                <h3 className="h5">UI/UX Design</h3>
                <p>
                  Crafting intuitive and engaging user
                  experiences with clean, modern, and user-friendly designs.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/team.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="feature-info-wrap">
                <h3 className="h5">It Consulting & Support </h3>
                <p>
                  We provide expert IT consulting and reliable support to help your
                  business make smarter technology decisions and stay running smoothly.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/promotion.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="feature-info-wrap">
                <h3 className="h5">Digital Marketing</h3>
                <p>
                  Driving business growth through targeted strategies,
                  online visibility, and meaningful customer engagement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicePromo;
